import { render, staticRenderFns } from "./the-top-bar.vue?vue&type=template&id=3b8ca36c&scoped=true&"
import script from "./the-top-bar.vue?vue&type=script&lang=js&"
export * from "./the-top-bar.vue?vue&type=script&lang=js&"
import style0 from "./the-top-bar.vue?vue&type=style&index=0&id=3b8ca36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ca36c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAppBarNavIcon,VSpacer})
